import { render, staticRenderFns } from "./PurchaseDeliveryDialog.vue?vue&type=template&id=2dbf85d7&scoped=true"
import script from "./PurchaseDeliveryDialog.vue?vue&type=script&lang=js"
export * from "./PurchaseDeliveryDialog.vue?vue&type=script&lang=js"
import style0 from "./PurchaseDeliveryDialog.vue?vue&type=style&index=0&id=2dbf85d7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbf85d7",
  null
  
)

export default component.exports